import { ComponentPropsWithRef } from "react";
import styled from "styled-components";
import { semanticRed02, shade0 } from "../../styles/tokens";
import { Body } from "../body/Body";

// TEXT

// STYLES
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ErrorMessage = styled(Body)`
  color: ${semanticRed02};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"div"> {
  message?: string;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
export const ErrorIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="8" fill={semanticRed02} />
    <rect x="9" y="5" width="2" height="7" rx="1" fill={shade0} />
    <rect x="9" y="13" width="2" height="2" rx="1" fill={shade0} />
  </svg>
);
